import React, { forwardRef, useState, useEffect } from 'react';

// LOCAL COMPONENTS
import TableRow from './TableRow';

const TableBody = forwardRef(
  (
    {
      rows,
      rowVirtualizer,
      ...props
    },
    ref
  ) => {
    const [height, setHeight] = useState(rowVirtualizer.getTotalSize());

    const newHeight = rowVirtualizer.getTotalSize();

    useEffect(() => {
        setTimeout(() => setHeight(newHeight), 200);
    }, [newHeight]);

    return (
      <tbody
        style={{ height: `${height}px` }}
        className="position-relative"
      >
        {rowVirtualizer.getVirtualItems().map(virtualRow => {
          const index = virtualRow.index;
          const row = rows[index];
          return (
            <TableRow
              {...props}
              key={index}
              index={index}
              ref={ref}
              row={row}
              rowVirtualizer={rowVirtualizer}
              virtualRow={virtualRow}
            />
          );
        })}
      </tbody>
    );
  }
);

export default TableBody;
